import PropTypes from 'prop-types';
import React from 'react';
import { Icon, Menu, Table } from 'semantic-ui-react';

import { calcPages } from '../../../utils/functions';

function TableFooterPagination({
  totalItems,
  colSpan,
  currentPage,
  totalPage,
  onPageClick,
}) {
  const handleClick = page => () => {
    if (typeof page === 'string') {
      const nextPage = currentPage + (page === 'prev' ? -1 : 1);
      if (nextPage > 0 && nextPage <= totalPage) {
        onPageClick(nextPage);
      }
    } else {
      if (page !== currentPage) {
        onPageClick(page);
      }
    }
  };


  return (
    <Table.Footer>
      <Table.Row>
        <Table.HeaderCell colSpan={colSpan}>
          <div className="Wrap-count-page">
            <p><b>{totalItems}</b> items </p>
            <p><b>{totalPage}</b> pages</p>
          </div>
          <Menu
            pagination
            className="Table-footer-pagination"
            style={{position: 'sticky', left: '10px'}}>
            <Menu.Item as="a" icon onClick={handleClick('prev')}>
              <Icon name="chevron left" />
            </Menu.Item>
            {calcPages(currentPage, totalPage).map(page => (
              <Menu.Item
                as="a"
                key={page}
                active={page === currentPage}
                onClick={handleClick(page)}
              >
                {page}
              </Menu.Item>
            ))}
            <Menu.Item as="a" icon onClick={handleClick('next')}>
              <Icon name="chevron right" />
            </Menu.Item>
          </Menu>
        </Table.HeaderCell>
      </Table.Row>
    </Table.Footer>
  );
}

TableFooterPagination.propTypes = {
  colSpan: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  totalPage: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
  onPageClick: PropTypes.func.isRequired,
};

export default TableFooterPagination;
